export const GET_CREDIT_LIMIT_MODEL_DATA = 'GET_CREDIT_LIMIT_MODEL_DATA';
export const GET_CREDIT_LIMIT_MODEL_DATA_SUCCESS = 'GET_CREDIT_LIMIT_MODEL_DATA_SUCCESS';
export const UPDATE_CREDIT_LIMIT_MODEL_REQUEST = 'UPDATE_CREDIT_LIMIT_MODEL_REQUEST';
export const UPDATE_CREDIT_LIMIT_MODEL_RESPONSE = 'UPDATE_CREDIT_LIMIT_MODEL_RESPONSE';

export const getCreditLimitModelData =(data)=>{
    return{
        type:GET_CREDIT_LIMIT_MODEL_DATA,
        data
    }
}

export const getCreditLimitModelDataSuccess =(data)=>{
    return{
        type:GET_CREDIT_LIMIT_MODEL_DATA_SUCCESS,
        data
    }
}

export const updateCreditLimitModelRequest =(data)=>{
    return{
        type:UPDATE_CREDIT_LIMIT_MODEL_REQUEST,
        data
    }
}

export const updateCreditLimitModelResponse =(data)=>{
    return{
        type:UPDATE_CREDIT_LIMIT_MODEL_RESPONSE,
        data
    }
}

